import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSummaryRoute: InvariantJiraRoute = {
	name: 'software-plan-summary',
	path: '/jira/plans/:planId/scenarios/:scenarioId/summary',
};
